import { Grid, Paper } from "@mui/material";
import React, { useEffect, useState } from "react";
import { Button, Input } from "../../../controls";
import { Model, UseForm } from "../../../hooks";
import { Form } from "../../../layout";
import { API, action, controller } from "../../../api/api";
import { RmvEmptyProp, ToFormData } from "../../../hooks/Method";

const AddEditBrand = (props) => {
  const {
    setAlert,
    setShowForm,
    updData,
    setBrands,
    // adding from other page params.
    openFromOtherSide = false,
    brandName = "",
    handleResult,
  } = props;
  const { BrandMdl } = Model();
  const [loading, setLoading] = useState(false);
  const {
    values,
    setValues,
    errors,
    setErrors,
    handleInpChg,
    resetFormControls,
  } = UseForm(BrandMdl);

  useEffect(() => {
    brandName && setValues((j) => ({ ...j, name: brandName }));
    return () => {};
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [brandName]);

  useEffect(() => {
    updData && setValues((x) => ({ ...x, ...updData }));
    return () => {
      resetFormControls();
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [updData]);

  const validateForm = () => {
    let temp = {};
    temp.name = values.name !== "" ? "" : "Name is required.";

    setErrors({ ...temp });
    return Object.values(temp).every((x) => x === "");
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    if (validateForm()) {
      setLoading(true);
      const onComplete = (res) => {
        setLoading(false);
        if (res && (res.status === 201 || res.status === 200)) {
          if (openFromOtherSide && handleResult) handleResult(res.result);
          else {
            updData
              ? setBrands((x) => [
                  ...x.map((j) => (j.id === res.result.id ? res.result : j)),
                ])
              : setBrands((x) => [res.result, ...x]);
            setAlert({
              isOpen: true,
              type: "success",
              title: "Success",
              subTitle: res.msg,
            });
          }
          setShowForm(false);
        } else if (res)
          setAlert({
            isOpen: true,
            type: "error",
            title: "Error",
            subTitle: res.msg,
          });
      };
      if (values.id === 0) {
        API(controller.Brand + action.Post).post(
          ToFormData(RmvEmptyProp({ ...values })),
          onComplete
        );
      } else
        API(controller.Brand + action.Put).put(
          ToFormData(
            RmvEmptyProp({ ...values, updateDate: new Date().toISOString() })
          ),
          onComplete
        );
    }
  };

  const handleClose = () => {
    setShowForm(false);
  };

  return (
    <>
      <Form onSubmit={handleSubmit} noValidate>
        <Paper>
          <Grid container spacing={2} className="p-[15px]">
            <Grid
              item
              xs={12}
              className="text-center p-[20px] !pt-[30px] w-[100%]"
            >
              <span className="text-[22px] font-medium uppercase text-gray-500">
                {updData ? "Update" : "Add"} Brand
              </span>
              <div className="flex justify-center">
                <div className="border-bottom w-[60px]" />
              </div>
            </Grid>
            <Grid item xs={12}>
              <Input
                label="Name"
                name="name"
                value={values.name}
                error={errors.name}
                required={true}
                inputProps={{ maxLength: 150 }}
                onChange={handleInpChg}
              />
            </Grid>
            <Grid item xs={12}>
              <Input
                label="Description"
                name="desc"
                value={values.desc}
                error={errors.desc}
                multiline
                rows={3}
                inputProps={{ maxLength: 500 }}
                onChange={handleInpChg}
              />
            </Grid>
            <Grid item xs={12}>
              <div className="flex gap-[10px]">
                <Button
                  fullWidth
                  size="large"
                  variant="text"
                  onClick={handleClose}
                >
                  Cancel
                </Button>

                <Button fullWidth size="large" loading={loading} type="submit">
                  Submit
                </Button>
              </div>
            </Grid>
          </Grid>
        </Paper>
      </Form>
    </>
  );
};

export default AddEditBrand;
